import api from './api.service';
import type {
  LLMModel,
  CreateLLMModelRequest,
  UpdateLLMModelRequest,
  SelectLLMModelRequest,
} from '@/types/llm-model.types';

// === LLM MODELS API ===

export const llmModelsApi = {
  /**
   * Lista todos os modelos LLM (apenas admin)
   */
  getAll: async (): Promise<LLMModel[]> => {
    const { data } = await api.get<LLMModel[]>('/api/llm-models');
    return data;
  },

  /**
   * Busca um modelo LLM por ID (apenas admin)
   */
  getById: async (id: number): Promise<LLMModel> => {
    const { data } = await api.get<LLMModel>(`/api/llm-models/${id}`);
    return data;
  },

  /**
   * Busca o modelo LLM selecionado (apenas admin)
   */
  getSelected: async (): Promise<LLMModel> => {
    const { data } = await api.get<LLMModel>('/api/llm-models/selected');
    return data;
  },

  /**
   * Cria um novo modelo LLM (apenas admin)
   */
  create: async (modelData: CreateLLMModelRequest): Promise<LLMModel> => {
    const { data } = await api.post<LLMModel>('/api/llm-models', modelData);
    return data;
  },

  /**
   * Atualiza um modelo LLM (apenas admin)
   */
  update: async (id: number, modelData: UpdateLLMModelRequest): Promise<LLMModel> => {
    const { data } = await api.put<LLMModel>(`/api/llm-models/${id}`, modelData);
    return data;
  },

  /**
   * Deleta um modelo LLM (apenas admin)
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/llm-models/${id}`);
  },

  /**
   * Seleciona um modelo LLM como ativo (apenas admin)
   */
  select: async (modelId: number): Promise<LLMModel> => {
    const request: SelectLLMModelRequest = { modelId };
    const { data } = await api.post<LLMModel>('/api/llm-models/select', request);
    return data;
  },
};
